import traverse from './traverse.js'

export default function prev_segment($input) {
	traverse($input, 'prev')
}
